export default {
  init: (arg1: any) => undefined,
  configureScope: () => false,
  captureException: (arg1: any, arg2: any) => String
}
